import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { getCategoryHeirarchy } from '../../redux/getCategoryHeirarchy';
import EditAdminForm from '../../component/adminComps/EditAdminForm';
import { getAllTypeCustomers } from '../../redux/customer/customerSlice';
import { useParams } from 'react-router-dom';
import { getAdminDetailsThunk } from '../../redux/admin/adminSlice';

const EditAdmin = () => {
  const { id } = useParams()

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllTypeCustomers());
    dispatch(getAdminDetailsThunk(id))

  }, []);

  return (
    <div >
      <NestedUserHeader 
        index="Edit Admin"
        root="admins"
        buttonText={'Back to list'}/>
      <EditAdminForm />
    </div>
  );

};

export default EditAdmin;
